import React, { FC, useState } from 'react'
import { FetchMore } from '@pandiafi/design-system'

import { DefectNoticeListItem } from '../../../common/validations/defectNotice'
import { DefectNoticeCard } from '../DefectNoticeCard'

const NBR_OF_DEFECT_NOTICES_TO_SHOW = 5

export const DefectNoticeList: FC<{
  defectNotices: DefectNoticeListItem[]
}> = ({ defectNotices }) => {
  const [showAll, setShowAll] = useState(false)
  const isShowMoreVisible =
    !showAll && defectNotices.length > NBR_OF_DEFECT_NOTICES_TO_SHOW
  const noticesToShow = showAll
    ? defectNotices
    : defectNotices.slice(0, NBR_OF_DEFECT_NOTICES_TO_SHOW)
  return (
    <div className="mt-4 mb-8 desktop:my-8 tablet:grid tablet:grid-cols-2 tablet:gap-x-8">
      {noticesToShow.map((notice) => (
        <div className="mt-4" key={`defectNotice-${notice.id}`}>
          <DefectNoticeCard defectNotice={notice} />
        </div>
      ))}
      {isShowMoreVisible && (
        <div className="text-center pt-3">
          <FetchMore
            fetchMoreItemsCount={
              defectNotices.length - NBR_OF_DEFECT_NOTICES_TO_SHOW
            }
            onFetchMoreItemsClick={() => setShowAll(true)}
          />
        </div>
      )}
    </div>
  )
}
